import type { IStringifyOptions as QueryStringifyOptions } from 'qs';
import qs from 'qs';

export type { QueryStringifyOptions };

export enum ArrayFormat {
  COMMA = 'comma',
  REPEAT = 'repeat',
}

const DEFAULT_PARAMS_OPTIONS = {
  skipNulls: true,
  arrayFormat: ArrayFormat.COMMA,
} as const;

/**
 * @see {@link https://github.com/ljharb/qs}
 * @param params query object
 * @param requestParamsOptions default { skipNulls: true, arrayFormat: 'comma' }
 * @returns stringified query string
 */
export const queryStringify = (
  params: Record<string, unknown>,
  requestParamsOptions?: QueryStringifyOptions,
) =>
  qs.stringify(params, {
    ...DEFAULT_PARAMS_OPTIONS,
    ...requestParamsOptions,
  });
